// src/http.ts
import axios from "axios";
function request(environment, config, mappers) {
  if (mappers) {
    if (config.params && mappers.params) {
      config.params = mappers.params(config.params);
    }
    if (config.data && mappers.req) {
      config.data = mappers.req(config.data);
    }
  }
  return new Promise((resolve, reject) => {
    axios.request({
      baseURL: environment.service,
      ...config
    }).then((res) => {
      if (mappers && mappers.res) {
        try {
          resolve(mappers.res(res.data));
        } catch (err) {
          reject({
            code: 406,
            type: err.name,
            message: err.message
          });
        }
      } else {
        resolve(res.data);
      }
    }).catch((err) => {
      if (err.response) {
        reject({
          code: err.response.status,
          type: err.response.statusText,
          message: err.message
        });
      } else {
        reject({
          code: 503,
          type: "Service Unavailable",
          message: "The server cannot be reached."
        });
      }
    });
  });
}

export {
  request
};
